import { PhoneVerificationApi } from 'services/access/api/PhoneVerificationApi';
import { stateHelper } from 'utilities/stateHelper';
import { McsErrors } from 'utils/McsErrors/McsErrors';
import { ReduxTypeUtils } from 'utils/ReduxTypeUtils';

import { CurrentUserActions } from '../../../../reactApp/modules/CurrentUserModule';
import * as VerificationTypes from './PhoneVerificationModule.types';

type VerificationModuleState = {
    sessionId: string | null;
};

const INITIAL_STATE: VerificationModuleState = {
    sessionId: null,
};

const module = stateHelper.createModuleState('verification', INITIAL_STATE);

type PhoneParams = {
    phone: number | string;
    verification_method?: string;
};
const phoneForward = ({
    phone,
    verification_method = 'sms',
}: PhoneParams): ReduxTypeUtils.ThunkResult<Promise<
    VerificationTypes.VerificationApiPhoneForward
>> => async (dispatch) => {
    try {
        const { session_id } = await PhoneVerificationApi.loadPhoneForward({
            phone,
            verification_method,
        });

        dispatch(module.setPart('sessionId', session_id));

        return { session_id };
    } catch (errorResponse) {
        throw McsErrors.getFormMessagesFromResponse(errorResponse, {
            fieldTexts: {
                default: 'Введено некорректное значение',
                phone: {
                    required: 'Заполните поле',
                    pattern: 'Неверный формат: +7 (123) 123-45-67',
                    invalid: 'Неверный формат: +7 (123) 123-45-67',
                    limit_exceeded: 'Данный номер уже используется',
                    ip_blocked: 'Ваш IP-адрес заблокирован',
                },
            },
            commonTexts: {
                default: 'При попытке получения кода произошла ошибка',
            },
        });
    }
};

export type CodeParams = {
    code: number;
    phone: string;
    session_id?: string;
};
const confirmCode = (params: CodeParams) => async (dispatch, getState) => {
    if (!params.session_id) {
        params.session_id = module.getModuleState(getState())
            .sessionId as string;
    }
    try {
        await PhoneVerificationApi.codeConfirm(params);
        dispatch(CurrentUserActions.setIsPhoneVerified(true));
        await dispatch(CurrentUserActions.setPhone(params.phone));
    } catch (errorResponce) {
        throw McsErrors.getFormMessagesFromResponse(errorResponce, {
            fieldTexts: {
                default: 'Неверный код подтверждения',
                code: {
                    required: 'Заполните поле',
                },
            },
            commonTexts: {
                default: 'При попытке получения кода произошла ошибка',
            },
        });
    }
};

export const PhoneVerificationActions = {
    phoneForward,
    confirmCode,
};

export const PhoneVerificationSelectors = {
    getSessionId: (state) => module.getPart(state, 'sessionId'),
};
